<template>
  <ul class="navbar-nav">
    <li v-for="navItem in navItems" :key="navItem.text" class="nav-item position-static active">
      <a class="nav-link" :href="`${navItem.href}`">{{ navItem.linkText }}</a>
    </li>
  </ul>
</template>

<script>
import sanity from "../../../../sanity.js";
const mainNavQuery = `*[_type == "navigation" && title == "Header Navigation"]{navItems[]{linkText, href}}`;
export default {
  name: "NavBasic",
  data() {
    return {
      loading: true,
      navItems: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.error = this.home = null;
      this.loading = true;
      sanity.fetch(mainNavQuery).then(
          (nav) => {
            this.loading = false;
            this.navItems = nav[0].navItems;
          },
          (error) => {
            this.error = error;
          }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.theme-menu-five, .theme-menu-four {
  .navbar-collapse {
    .navbar-nav {
      .nav-item {
        .nav-link {
          border-radius: 0.5rem;
          color: var(--darkblue);
          margin: 0;
          padding: 0.5rem 1rem;
          &:hover {
            background-color: var(--green);
            border-radius: 0.25rem;
            color: var(--darkblue);
          }
        }
      }
    }
  }
}
</style>
